import React from 'react';
import moment from 'moment';
import { Form, Row, Col, Button, Affix } from 'antd';
import AddPerformerFields from './AddPerformerFields';

class AddPerformerInfo extends React.Component {
  handleCheckDisable = () => {
    const { progress } = this.props;
    return !progress.every(r => r.completed);
  };
  render() {
    const { form } = this.props;
    return (
      <div id="addPerformer" className="basicForm">
        <Row type="flex" justify="space-between" gutter={16}>
          <Col span={18}>
            <div className="formContainer">
              <AddPerformerFields form={form} />
            </div>
          </Col>
          <Col span={6} className="offer-card__status order-card__sidebar">
            <Affix offsetTop={18} target={() => document.getElementById('mainSheet')}>
              <div className="button">
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={this.handleCheckDisable()}
                  // onClick={handleFormSubmit}
                >
                  Сохранить
                </Button>
              </div>
            </Affix>
          </Col>
        </Row>
      </div>
    );
  }
}

class AddPerformerData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
    };
    this.defaultProfileData = {};
    this.flagInitEditing = false;
  }
  componentDidMount() {
    this.initEditing();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    this.initEditing();
    if (this.props.checkFormErrors) {
      this.props.checkFormErrors(this.props.name);
    }
  }
  initEditing = () => {
    let { isEditable } = this.props;
    let dataProps = this.props.data;
    if (!this.flagInitEditing && isEditable) {
      this.flagInitEditing = true;

      let newEditData = {};
      if (dataProps) {
        Object.keys(dataProps).forEach(item => {
          newEditData[item] = {
            value: dataProps[item],
          };
        });
      }
      this.setState({ data: newEditData }, () => {
        // проверить все поля на валидность
        if (this.formRef) {
          this.formRef.validateFields((errors, values) => {
            this.changeValues(values);
          });
        }
      });
    } else if (!isEditable && this.flagInitEditing) {
      this.flagInitEditing = false;
    }
  };
  getValueByFieldName(name, val) {
    if (name.includes('Date')) {
      return (val && moment(val)) || null;
    } else {
      return val;
    }
  }
  saveFormRef = formRef => {
    if (formRef && formRef.props && formRef.props.form) {
      this.formRef = formRef.props.form;
    }
    // else {
    //   this.formRef = null;
    // }
    this.props.setForm(this.props.name, this.formRef);
  };

  handleFieldsChange = values => {
    this.setState(
      {
        data: {
          ...this.state.data,
          ...values,
        },
      },
      () => {
        this.changeValues(values);
      }
    );
  };

  changeValues = values => {
    if (this.formRef) {
      // Обновляем прогресс заполнения
      this.props.updateProgress(values, this.props.name);
    }
  };
  render() {
    const { isEditable } = this.props;
    // const data = this.props.data;
    const data = isEditable
      ? this.state.data
      : this.props.data || this.defaultProfileData;
    return (
      <FormAddPerformer
        {...this.props}
        data={data}
        wrappedComponentRef={this.saveFormRef}
        getValueByFieldName={this.getValueByFieldName}
        handleFieldsChange={this.handleFieldsChange}
      />
    );
  }
}

const FormAddPerformer = Form.create({
  name: 'formAddPerformer',
  onFieldsChange(props, changedFields) {
    props.handleFieldsChange(changedFields);
  },
  mapPropsToFields(props) {
    let obj = {};
    props.data &&
      Object.keys(props.data).forEach(name => {
        obj[name] = Form.createFormField({
          ...(props.isEditable ? props.data[name] : {}),
          value: props.getValueByFieldName(
            name,
            props.isEditable ? props.data[name].value : props.data[name]
          ),
        });
      });
    console.log(obj);
    return obj;
  },
  onValuesChange(props, values) {},
})(AddPerformerInfo);

export default AddPerformerData;
